const fileDomainSize: Record<string, Record<string, any>> = {};
const domainMap: Record<string, string[]> = {};
const domainLinks: string[] = [];
const adDomainMap: Record<string, any> = {};
const modules = import.meta.glob("./modules/*.ts", {
  import: "default",
  eager: true,
});
Object.keys(modules).forEach(key => {
  const filename = key.split("/").pop()?.replace(".ts", "");
  if (typeof filename === "string" && !fileDomainSize[filename]) {
    const module = modules[key] as Record<string, any>;
    if (module && typeof module === "object" && Object.keys(module).length > 0) {
      domainMap[filename] = [];
      domainMap[filename].push(...Object.keys(module));
      domainLinks.push(...Object.keys(module));
      fileDomainSize[filename] = module;
      Object.keys(module).forEach(key => {
        adDomainMap[key] = module[key];
      });
    }
  }
});
if (isDevEnv || isBuildTest) {
  console.table({
    fileDomainSize,
    adDomainMap,
    domainMap,
    domainLinks,
  });
}
const wgDomains1 = ["en-wg.comfortweather.com"];
const wgDomains2 = ["rs-wg.comfortweather.com"];
const wgDomains3 = ["mos.comfortweather.com"];
const miwgDomain1 = ["en-miwg.comfortweather.com"];
const milsDomain1 = ["rs-mils.comfortweather.com"];
const wwwDomain1 = ["www.comfortweather.com"];
export {
  fileDomainSize,
  domainMap,
  domainLinks,
  adDomainMap,
  wgDomains1,
  wgDomains2,
  miwgDomain1,
  wgDomains3,
  milsDomain1,
  wwwDomain1,
};
